import { useState, useEffect } from 'react';
import styled, { keyframes, useTheme } from 'styled-components';
import Icon from '../Icon';

const rotate = keyframes`
  from {
    right: -18rem;
  }
  to {
    right: 0;
  }
`;

const Toast = styled.div`
  align-items: center;
  animation: ${rotate} 0.6s ease-in;
  background-color: white;
  border: 2px solid black;
  border-right: 0;
  color: ${(props) => props.theme.color.basicFontColor};
  display: flex;
  font-size: 14px;
  height: auto;
  justify-content: center;
  max-width: 18rem;
  position: fixed;
  right: 0;
  top: 25%;
  line-height: 2;
  z-index: 999;
`;

const ToastContainer = styled.div`
  padding: 2rem;
  position: relative;
  height: 100%;
  width: 100%;
`;

const CloseBtn = styled.div`
  cursor: pointer;
  position: absolute;
  right: 3%;
  top: 6%;
`;

const StyledIcon = styled(Icon)`
  color: black;
  width: 13px;
  height: 13px;
  margin-left: 20px;
`;

/**
 * @param {ToastMessageProps} props
 * @returns {React.ReactElement} The rendered component
 */
const ToastMessage = ({ message }) => {
  const [bookmarkLimitMessage, setBookmarkLimitMessage] = useState(false);
  const theme = useTheme();

  function getBookmarkCount() {
    const local = localStorage?.getItem(theme.bookmarkName);
    if (local !== null && local.length > 0) {
      const existingBookmarks = JSON.parse(local);
      if (existingBookmarks?.length >= theme.bookmarkLimit - 1) {
        if (!bookmarkLimitMessage) {
          setBookmarkLimitMessage(true);
        }
      }
    }
  }

  useEffect(() => {
    if (!bookmarkLimitMessage) {
      window.addEventListener('bookmarklimit', getBookmarkCount);
    }
    return () => window.removeEventListener('bookmarklimit', getBookmarkCount);
  });

  return (
    <>
      {bookmarkLimitMessage && (
        <Toast>
          <ToastContainer>
            <CloseBtn
              onClick={() => {
                setBookmarkLimitMessage(false);
              }}
            >
              <StyledIcon icon="CLOSE" />
            </CloseBtn>
            {message}
          </ToastContainer>
        </Toast>
      )}
    </>
  );
};

export default ToastMessage;
